var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.09 7.04l7.84 4.46-7.84 4.46V7.04zM3.436 21.437c2.34.63 11.72.63 11.72.63s9.382 0 11.722-.63a3.772 3.772 0 002.652-2.67c.627-2.354.627-7.268.627-7.268s0-4.913-.627-7.268a3.771 3.771 0 00-2.652-2.67c-2.34-.63-11.721-.63-11.721-.63s-9.381 0-11.721.631a3.769 3.769 0 00-2.652 2.67C.158 6.587.158 11.5.158 11.5s0 4.914.627 7.267a3.77 3.77 0 002.652 2.67z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "961f083b5f8e7b1e7b04da72d50abae0.svg";
export { SvgYoutube as ReactComponent };